import { render } from "./PremiumBanner.vue?vue&type=template&id=206d90b6"
import script from "./PremiumBanner.vue?vue&type=script&lang=js"
export * from "./PremiumBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__